import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { MARKETING_EXTENDED_REPORT } = API_URLS;

const getProcessedMarketingAttributionReportGraphData = (body) => {
  return postRequest(
    MARKETING_EXTENDED_REPORT.PREPROCESSED_GRAPH_DATA,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getProcessedMarketingAttributionReportPaginatedData = (body) => {
  return postRequest(
    MARKETING_EXTENDED_REPORT.PREPROCESSED_PAGINATED_DATA,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const processedMarketingAttributionReportServices = {
  getProcessedMarketingAttributionReportGraphData,
  getProcessedMarketingAttributionReportPaginatedData,
};
